import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './JobApplication.css';

function JobApplication() {
  const { jobId } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [applicationForm, setApplicationForm] = useState({
    name: '', email: '', phone: '', message: '', cv: null, coverLetter: null
  });

  useEffect(() => {
    fetchJob();
  }, [jobId]);

  const fetchJob = async () => {
    try {
      const response = await axios.get('/api/jobs');
      const foundJob = response.data.find(j => j.id === parseInt(jobId));
      setJob(foundJob);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching job:', error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('jobId', jobId);
      formData.append('name', applicationForm.name);
      formData.append('email', applicationForm.email);
      formData.append('phone', applicationForm.phone);
      formData.append('message', applicationForm.message);
      
      if (applicationForm.cv) {
        formData.append('cv', applicationForm.cv);
      }
      if (applicationForm.coverLetter) {
        formData.append('coverLetter', applicationForm.coverLetter);
      }
      
      await axios.post('/api/job-applications', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      alert('Application submitted successfully!');
      setApplicationForm({ name: '', email: '', phone: '', message: '', cv: null, coverLetter: null });
    } catch (error) {
      alert(error.response?.data?.error || 'Error submitting application');
    }
  };

  if (loading) {
    return <div className="job-loading">Loading...</div>;
  }

  if (!job) {
    return (
      <div className="job-not-found">
        <h1>Job Not Found</h1>
        <p>This job posting is no longer available.</p>
      </div>
    );
  }

  return (
    <div className="job-application-page">
      <div className="job-application-container">
        <div className="job-header-section">
          <h1>{job.title}</h1>
          <div className="job-meta-large">
            <span className="job-type-badge">{job.type}</span>
            {job.location && <span className="meta-item">📍 {job.location}</span>}
            {job.salary && <span className="meta-item">💰 {job.salary}</span>}
          </div>
        </div>

        <div className="job-content-section">
          <div className="job-info-section">
            <h2>Job Description</h2>
            <p>{job.description}</p>
          </div>

          {job.requirements && (
            <div className="job-info-section">
              <h2>Requirements</h2>
              <p>{job.requirements}</p>
            </div>
          )}

          <div className="application-section">
            <h2>Apply for this Position</h2>
            <form onSubmit={handleSubmit} className="application-form">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Full Name *"
                  value={applicationForm.name}
                  onChange={(e) => setApplicationForm({...applicationForm, name: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  placeholder="Email Address *"
                  value={applicationForm.email}
                  onChange={(e) => setApplicationForm({...applicationForm, email: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={applicationForm.phone}
                  onChange={(e) => setApplicationForm({...applicationForm, phone: e.target.value})}
                />
              </div>

              <div className="form-group">
                <textarea
                  placeholder="Why are you interested in this position?"
                  value={applicationForm.message}
                  onChange={(e) => setApplicationForm({...applicationForm, message: e.target.value})}
                  rows="5"
                />
              </div>

              <div className="file-uploads">
                <div className="file-upload-box">
                  <label>
                    📄 Upload CV (optional)
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={(e) => setApplicationForm({...applicationForm, cv: e.target.files[0]})}
                    />
                    {applicationForm.cv && <span className="file-selected">{applicationForm.cv.name}</span>}
                  </label>
                </div>

                <div className="file-upload-box">
                  <label>
                    📝 Upload Cover Letter (optional)
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={(e) => setApplicationForm({...applicationForm, coverLetter: e.target.files[0]})}
                    />
                    {applicationForm.coverLetter && <span className="file-selected">{applicationForm.coverLetter.name}</span>}
                  </label>
                </div>
              </div>

              <button type="submit" className="submit-btn">Submit Application</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobApplication;
